import LigdiCashIcon from '../../assets/icons/payment-providers/LigdiCashIcon';
import OrangeMoneyIcon from '../../assets/icons/payment-providers/OrangeMoneyIcon';
import MoovAfricaIcon from '../../assets/icons/payment-providers/MoovAfricaIcon';
import { PAYMENT_METHOD } from '../../types/enums';
import type { PaymentProvider } from '../../types/payment';

export const ligdiCashPaymentProviders: PaymentProvider[] = [
  {
    label: 'LigdiCash',
    value: PAYMENT_METHOD.LIGDICASH,
    icon: LigdiCashIcon,
  },
  {
    label: 'Orange Money',
    value: PAYMENT_METHOD.ORANGE_MONEY_BURKINA,
    icon: OrangeMoneyIcon,
    disableWithdraw: true,
  },
  {
    label: 'Moov',
    value: PAYMENT_METHOD.MOOV_AFRICA,
    icon: MoovAfricaIcon,
    disableWithdraw: true,
  },
];
